import { render, staticRenderFns } from "./NavigationOperatore.vue?vue&type=template&id=0bfcaa8b&scoped=true"
import script from "./NavigationOperatore.vue?vue&type=script&lang=js"
export * from "./NavigationOperatore.vue?vue&type=script&lang=js"
import style0 from "./NavigationOperatore.vue?vue&type=style&index=0&id=0bfcaa8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfcaa8b",
  null
  
)

export default component.exports